var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2066,
    height: 212,
    viewBox: "0 0 2066 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228 181C257 190.001 385 232.5 483.663 181.999C710.942 65.6658 696.654 -25.7728 978.933 15.3701C1261.21 56.513 1278.32 225.199 1582.84 140.856C1887.36 56.5128 1978.03 56.513 2061 56.513",
    stroke: "#FF2521",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "32 32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 54.9999C52 97 132 153.5 230 181.5",
    stroke: "#00CA9A",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "32 32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.67af67bd7d2318c0c4d071bfe62e8ae6.svg";
export { ForwardRef as ReactComponent };